import React from "react";
import { Marker, Popup } from "react-leaflet";
import L from "leaflet";
import CustomerLink from '../../Components/CustomerLink';

const StoreTrackMarkers = ({ storeLocations, currenttime, zoomedIn }) => {
    // Helper function to determine the icon type
    const determineIcon = (store) => {
        if (store.trackingType) {
            switch (store.trackingType) {
                case 'BUY':
                    return "/store-icon2.png"; // Green/Success icon
                case 'NOT_BUY':
                    return "/store2-icon.png"; // Yellow/Visited but not bought icon
                case 'NOT_VISITED':
                    return "/store-icon.png"; // Default icon
                case 'TIME_NULL':
                    return "/store1-icon.png"; // Gray/No time icon
                default:
                    return "/store-icon.png";
            }
        }

        const saletime = store.saletime;
        if (!saletime) {
            return "/store1-icon.png";
        }

        const saletimes = saletime.split(", ").map((time) => time.trim());
        const currentTime = new Date(`1970-01-01T${currenttime}Z`).getTime();

        let hasPassed = false;

        for (let time of saletimes) {
            const saleTime = new Date(`1970-01-01T${time}Z`).getTime();
            const timeDifference = Math.abs(currentTime - saleTime) / 1000;

            if (timeDifference <= 120) {
                return "/store-icon2.png";
            }

            if (currentTime > saleTime) {
                hasPassed = true;
            }
        }

        if (hasPassed) {
            return "/store2-icon.png";
        }

        return "/store-icon.png";
    };

    return (
        <>
            {storeLocations.map((store) => {
                const position = [store.latitude, store.longitude];
                const iconUrl = determineIcon(store);

                const customIcon = L.divIcon({
                    html: `
                        <div style="position: relative; text-align: center;">
                            ${
                        zoomedIn
                            ? `<div style="
                                            position: absolute; 
                                            bottom: 45px; 
                                            left: 50%; 
                                            width: 100px;
                                            transform: translateX(-50%); 
                                            background-color: rgba(255, 255, 255, 0.5);
                                            padding: 2px 5px; 
                                            border-radius: 3px; 
                                            font-size: 12px; 
                                            font-weight: bold; 
                                            color: ${store.purchaseToday ? "#039311" : "#0275d8"};
                                            box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.2);
                                            z-index: 1000;
                                        ">
                                            ${store.storeName}
                                        </div>`
                            : ""
                    }
                            <img src="${iconUrl}" alt="store-icon" />
                        </div>
                    `,
                    className: "custom-icon",
                    iconSize: [25, 41],
                    iconAnchor: [12, 50],
                    popupAnchor: [0, -50], // Adjust popupAnchor to bring popup above marker
                });

                return (
                    <Marker
                        key={store.id}
                        position={position}
                        icon={customIcon}
                    >
                        <Popup>
                            <div
                                style={{
                                    maxWidth: "250px",
                                    fontFamily: "Arial, sans-serif",
                                    fontSize: "14px",
                                    color: "#333",
                                    zIndex: 1000 // Ensure popup appears on top
                                }}
                            >
                                <h3
                                    style={{
                                        margin: "0 0 10px 0",
                                        fontSize: "16px",
                                        color: "#0275d8",
                                        textAlign: "center",
                                    }}
                                >
                                    <CustomerLink name={store.storeName} code={store.id} type={store.customerType} />
                                </h3>
                                <p style={{margin: "5px 0"}}>
                                    <strong>Latitude:</strong> {store.latitude}
                                </p>
                                <p style={{margin: "5px 0"}}>
                                    <strong>Longitude:</strong> {store.longitude}
                                </p>
                                <div style={{margin: "10px 0"}}>
                                    <strong>Saletime:</strong> {store.saletime || "No saletime"}
                                </div>
                                {store.actualTime && (
                                    <div style={{margin: "10px 0", color: "#46af38"}}>
                                        <strong>Actual Time:</strong> {store.actualTime}
                                    </div>
                                )}
                                {store.trackingType && (
                                    <div style={{margin: "10px 0", fontWeight: "bold"}}>
                                        <strong>Status:</strong> {
                                            store.trackingType === 'BUY' ? 'ซื้อแล้ว' :
                                            store.trackingType === 'NOT_BUY' ? 'เข้าพบแต่ไม่ซื้อ' :
                                            store.trackingType === 'NOT_VISITED' ? 'ยังไม่เข้าพบ' :
                                            store.trackingType === 'TIME_NULL' ? 'ไม่ระบุเวลา' : store.trackingType
                                        }
                                    </div>
                                )}
                                {store.saleItems?.length > 0 && (
                                    <div style={{margin: "10px 0"}}>
                                        <strong>Sale Items:</strong>
                                        {store.saleItems.map((item, index) => (
                                            <div key={index} style={{marginLeft: "10px"}}>
                                                {item.saleItemName} - {item.averageQuantity}
                                            </div>
                                        ))}
                                    </div>
                                )}
                                {store.daliveryOder && (
                                    <div style={{margin: "10px 0", color: "#ff6347"}}>
                                        <strong>Delivery Oder:</strong> {store.daliveryOder}
                                    </div>
                                )}

                                <div style={ { textAlign: "right"}}>
                                <i
                                    className="fa-solid fa-map"
                                    style={{cursor: "pointer", fontSize: "20px", color: "gray", marginRight: "10px" }}
                                    onClick={() => {
                                        const mapUrl = `https://www.google.com/maps/place/${position[0]}+${position[1]}/@${position[0]},${position[1]},150m`;
                                        window.open(mapUrl, "_blank");
                                    }}
                                ></i>
                                </div>
                            </div>
                        </Popup>
                    </Marker>
                );
            })}
        </>
    );
};

export default StoreTrackMarkers;
